var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 19.2C1.74 19.2 1.1748 18.9648 0.704402 18.4944C0.234002 18.024 -0.000797963 17.4592 2.03735e-06 16.8V2.4C2.03735e-06 1.74 0.235202 1.1748 0.705602 0.704402C1.176 0.234002 1.7408 -0.000797963 2.4 2.03735e-06H21.6C22.26 2.03735e-06 22.8252 0.235202 23.2956 0.705602C23.766 1.176 24.0008 1.7408 24 2.4V16.8C24 17.46 23.7648 18.0252 23.2944 18.4956C22.824 18.966 22.2592 19.2008 21.6 19.2H2.4ZM12 10.8L21.6 4.8V2.4L12 8.4L2.4 2.4V4.8L12 10.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.392319b28a9fac03a5220fee40e72357.svg";
export { ForwardRef as ReactComponent };